// © 2023 Amazon Web Services, Inc. or its affiliates. All Rights Reserved.
// This AWS Content is provided subject to the terms of the AWS Customer Agreement available at
// http://aws.amazon.com/agreement or other written agreement between Customer and either
// Amazon Web Services, Inc. or Amazon Web Services EMEA SARL or both.
import { useEffect, useRef } from "react";

const DEFAULT_INTERVAL_MS = 15000;

// Replaces the AppSync onCreateRequests/onUpdateRequests subscriptions, which
// can never fire because the `requests` model has subscriptions disabled in
// schema.graphql (@model(subscriptions: { level: off })).
function usePolling(callback, intervalMs = DEFAULT_INTERVAL_MS) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const id = setInterval(() => callbackRef.current(), intervalMs);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalMs]);
}

export default usePolling;
